import React, { Component } from "react"
import { withStyles } from "@material-ui/core"

import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"
import * as constants from "../constants"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class BodyCarAccBank extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  bodycarAccBankState: this.props.bodycarAccBank,
                  selectedBodycarAccBank: {
                        value: this.props.bodycarAccBank.bodycar_price_accbank_bodycar_discnt_accbank_id,
                        label: this.props.bodycarAccBank.bodycar_discnt_accbank_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionBodycarAccBank: [],
            }
      }
      componentDidMount() {
            this.getoptionBodycarAccBank()
      }

      getoptionBodycarAccBank = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].bodycar_discnt_accbank_id, label: arr.data[k].bodycar_discnt_accbank_name })
                              }
                              self.setState({ optionBodycarAccBank: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_discnt_accbank")
            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedBodycarAccBank) => {
            var temparray = this.state.bodycarAccBankState
            temparray.bodycar_price_accbank_bodycar_discnt_accbank_id = selectedBodycarAccBank.value
            this.setState({ selectedBodycarAccBank: selectedBodycarAccBank, bodycarAccBankState: temparray })
      }

      handleChangeConditionsPercent = (event) => {
            var temparray = this.state.bodycarAccBankState
            temparray.bodycar_price_accbank_percent = event
            this.setState({ bodycarAccBankState: temparray })
      }

      modifyNewInstalmentCondition = () => {
            const { bodycarAccBankState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_priceaccbank")
            fd.append("bodycar_price_accbank_id", bodycarAccBankState.bodycar_price_accbank_id)
            fd.append("bodycar_price_accbank_percent", bodycarAccBankState.bodycar_price_accbank_percent)

            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { bodycarAccBankState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_priceaccbank")
            fd.append("bodycar_price_accbank_id", bodycarAccBankState.bodycar_price_accbank_id)

            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { optionBodycarAccBank, snackMode, snackstr, showSnack, visible, selectedBodycarAccBank, bodycarAccBankState } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={5}>
                                    <div>
                                          <label className="on">بانک های طرف قرارداد </label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"بانک های طرف قرارداد"}
                                                value={selectedBodycarAccBank}
                                                onChange={this.handleInstalmentMode}
                                                options={optionBodycarAccBank}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={4}>
                                    <FloatingLabelInput
                                          type="percent"
                                          placeholder="درصد تخفیف حساب بلند مدت بانکی"
                                          handleInputt={this.handleChangeConditionsPercent}
                                          value={bodycarAccBankState.bodycar_price_accbank_percent}
                                    />
                              </Grid>

                              <Grid item xs={3}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(BodyCarAccBank)
